<template>
  <div>
    <AppHeader />
    <div v-if="loaded" class="team">
      <div class="team__preview">
        <v-container class="team__preview-inner">
          <v-layout row class="white--text">
            <v-flex xs12 class="team__info">
              <div class="team__about">
                <v-avatar
                  :size="100"
                  color="grey lighten-4"
                  class="team__avatar"
                >
                  <img
                    v-if="getTeam.avatar"
                    :src="getTeam.avatar"
                    alt="avatar"
                  />
                  <i
                    v-else
                    class="fas fa-user fa-3x"
                    style="height: 40px; width: 40px; color: #212121"
                  />
                </v-avatar>
              </div>

              <div class="team__activities">
                <div class="team__activities-item">
                  <h3 class="team__about-title">
                    {{ getTeam.name }}
                  </h3>
                  <h3 class="team__activities-title teal--text text--lighten-2">
                    NMG Miles
                  </h3>
                  <div class="team__activities-value">
                    {{ getTeam.total_nmg_miles }}
                  </div>
                </div>
                <!-- <div class="team__activities-item">
                <h3 class="team__activities-title teal--text text--lighten-2">
                  ZAR
                </h3>
                <div class="team__activities-value">
                  {{getTeam.total_zar}}
                </div>
              </div> -->
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
      <v-container>
        <v-layout row wrap>
          <v-flex xs12>
            <v-btn
              v-if="isTeamOwner"
              large
              round
              outline
              color="grey darken-1"
              style="width: 150px"
              @click.stop="editTeamDialogOpen"
            >
              Edit team
            </v-btn>
            <v-btn
              v-if="isTeamOwner"
              large
              round
              outline
              color="grey darken-1"
              style="width: 150px"
              @click.stop="editTeamMembersDialog = true"
            >
              Edit members
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container grid-list-xl>
        <v-layout>
          <h3 class="app-title">
            {{ getTeam.name }} - Team Members
          </h3>
        </v-layout>
        <v-layout>
          <v-flex>
            <LeaderBoardTable
              :table-items="getTeam.members_detail"
              :heading-items="individualLeaderboardPersonalHeaders"
            />
            <!-- <swiper
              v-if="loaded"
              :options="swiperOption"
            >
              <swiper-slide
                v-for="(item, index) in getTeam.members_detail"
                :key="item.id"
                class="team-slider py-2"
              >
                <v-card
                  class="team-slider__item text-xs-center pt-3 mx-1"
                  style="cursor: pointer;"
                  @click="redirectToProfile(item.id)"
                >
                  <v-avatar
                    :size="130"
                    color="grey lighten-4"
                    class="team-activity__total_avatar"
                    style="border-top-left-radius: 100%; border-top-right-radius: 100%; border-bottom-left-radius: 100%; border-bottom-right-radius: 100%;"
                  >
                    <img
                      v-if="item.avatar"
                      :src="item.avatar"
                      alt="avatar"
                    >
                    <i
                      v-else
                      class="fas fa-user fa-4x"
                      style="color: #212121; border-radius: 100%;"
                    />
                  </v-avatar>
                  <v-card-title
                    class="subheading text-xs-center font-weight-bold"
                    style="justify-content: center;"
                  >
                    {{ item.short_name }}
                  </v-card-title>
                  <hr>
                  <v-card-title class="d-block text-xs-left">
                    <span class="d-block">
                      <span class="font-weight-bold">
                        {{ item.total_nmg_miles }}
                      </span>
                      <span class="grey--text darken-1">
                        NMG Miles
                      </span>
                    </span>
                  </v-card-title>
                </v-card>
              </swiper-slide>
            </swiper> -->
          </v-flex>
        </v-layout>
      </v-container>

      <v-container>
        <v-layout>
          <v-flex xs12>
            <h3 class="app-title">
              Recent activity
            </h3>
            <div class="team-statistics">
              <table class="team-statistics__table text-left">
                <tr>
                  <th class="team-statistics__table-heading">
                    Member
                  </th>
                  <th class="team-statistics__table-heading">
                    Activity
                  </th>
                  <th class="team-statistics__table-heading">
                    Amount
                  </th>
                  <th class="team-statistics__table-heading">
                    Date
                  </th>
                  <!--  <th
                    class="team-statistics__table-heading"
                  >
                    Action
                  </th>-->
                </tr>
                <tr
                  v-for="activity in getTeam.recent_activity"
                  :key="activity.id"
                >
                  <td class="team-statistics__table-cell">
                    {{ activity.track_username }}
                  </td>
                  <td class="team-statistics__table-cell">
                    {{
                      activity.activity.indexOf("(") > 0
                        ? activity.activity
                            .substr(0, activity.activity.indexOf("("))
                            .trim()
                        : activity.activity.trim()
                    }}
                  </td>
                  <td class="team-statistics__table-cell">
                    {{ (activity.points * 1).toFixed(1) }}
                    <span
                      class="team-statistics__activity-value grey--text darken-1"
                    >
                      {{ activity.input === "Hour" ? "Hr" : activity.input }}
                    </span>
                  </td>
                  <td
                    class="team-statistics__table-cell team-statistics__date grey--text darken-1"
                  >
                    {{ activity.date_record | moment }}
                  </td>
                </tr>
              </table>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
      <v-dialog
        v-model="editTeamDialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        dark
        class="edit-dialog"
      >
        <div class="edit-dialog__inner">
          <v-toolbar fixed dark color="dark">
            <v-btn icon dark @click="editTeamDialog = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Edit team</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-btn dark flat @click="editTeamDialogSave">
                Save
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-container>
            <v-layout row wrap>
              <v-flex xs12>
                <v-form>
                  <div class="edit-dialog__avatar">
                    <v-avatar
                      :size="150"
                      color="grey lighten-4"
                      class="team__avatar"
                    >
                      <img
                        v-if="getTeam.avatar"
                        :src="getTeam.avatar"
                        alt="avatar"
                      />
                      <i
                        v-else
                        class="fas fa-user fa-5x"
                        style="color: #212121"
                      />
                    </v-avatar>
                    <v-btn
                      color="teal lighten-2"
                      flat
                      class="edit-dialog__button"
                      @click="pickFile"
                    >
                      Change photo
                    </v-btn>
                    <input
                      ref="changeTeamImage"
                      name="avatar"
                      type="file"
                      style="display: none"
                      accept="image/*"
                      @change="onFilePicked"
                    />
                  </div>
                  <v-text-field
                    v-if="isTeamOwner"
                    v-model="teamForm.name"
                    color="teal lighten-2"
                    outline
                    class="theme round"
                    label="name"
                    :error-messages="getError['name']"
                    prepend-inner-icon="fas fa-user fa-1x"
                  />
                  <span color="white">{{ getError["detail"] }}</span>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </v-dialog>

      <v-dialog
        v-model="editTeamMembersDialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        dark
        class="edit-dialog"
      >
        <div class="edit-dialog__inner">
          <v-toolbar fixed dark color="dark">
            <v-btn icon dark @click="editTeamMembersDialog = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Edit team members</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-btn dark flat @click="editTeamMembersDialogSave">
                Remove
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-container>
            <v-layout row wrap>
              <v-flex xs12>
                <v-form>
                  <table class="edit-dialog__table" valign="top">
                    <tr>
                      <th
                        class="edit-dialog__table-heading edit-dialog__table-row-checkbox"
                      >
                        <v-checkbox color="teal lighten-2" />
                      </th>
                      <th class="edit-dialog__table-heading">
                        Member
                      </th>
                    </tr>

                    <tr v-for="member in filtredMembersDetail" :key="member.id">
                      <td class="edit-dialog__table-row-checkbox">
                        <v-checkbox
                          v-model="membersToDelete"
                          :value="member.id"
                          color="teal lighten-2"
                        />
                      </td>
                      <td>
                        <v-avatar
                          :size="25"
                          color="amber darken-3"
                          class="mr-2"
                        >
                          <img
                            v-if="member.avatar"
                            :src="member.avatar"
                            alt="avatar"
                          />
                          <i
                            v-else
                            class="fas fa-user fa-sm"
                            style="color: #212121"
                          />
                        </v-avatar>
                        <span>{{ member.short_name }}</span>
                      </td>
                    </tr>
                  </table>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </v-dialog>

      <BottomNavigation />
    </div>
    <div v-else>
      <v-progress-linear :indeterminate="true" />
    </div>
  </div>
</template>

<script>
import AppHeader from "../components/AppHeader";
import BottomNavigation from "../components/BottomNavigation";
import LeaderBoardTable from "../components/leaderboard-table/LeaderBoardTable";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "Team",
  components: {
    AppHeader,
    BottomNavigation,
    LeaderBoardTable
  },
  filters: {
    moment(date) {
      return moment(date).format("MM/DD");
    }
  },
  data() {
    return {
      editTeamDialog: false,
      loaded: false,
      // editTeamImageDialog: false,
      editTeamMembersDialog: false,
      trackDeleteConfirmDialog: false,
      track: "",
      user_activity: false,
      selectedFile: null,
      membersToDelete: [],
      teamForm: {},
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 20,
        // init: false,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 40
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 30
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 10
          }
        }
      },
      teamsLeaderboardHeaders: [
        {
          text: "Team"
        },
        {
          //text: 'Zar/Person',
          text: "NMG miles/Person"
        }
      ],
      individualLeaderboardPersonalHeaders: [
        {
          text: "Member"
        },
        {
          text: "NMG miles"
        }
      ]
    };
  },
  computed: {
    ...mapGetters("team", ["getTeam", "getError"]),
    ...mapGetters("user", ["user", "error"]),
    isTeamOwner: function() {
      return this.getTeam.owner === this.user.id;
    },
    isTeamMember: function() {
      return this.getTeam.members.includes(this.user.id);
    },

    filtredMembersDetail: function() {
      return this.getTeam.members_detail.filter(i => i.id != this.user.id);
    }
  },
  mounted() {
    this.$store.dispatch("user/getUser");
    this.$store
      .dispatch("team/loadTeam", this.$route.params.id)
      .then(() => {
        this.loaded = true;
      })
      .catch(err => {});
  },
  methods: {
    redirectToProfile: function(user_id) {
      //const user_id = localStorage.getItem('user_id');
      //this.$store.dispatch('user/getUser', user_id);
      this.$router.push(`/user/${user_id}`);
    },
    editTeamMembersDialogSave: function() {
      let formData = new FormData();
      const team_id = this.$route.params.id;
      //const members = this.getTeam.map(i => members.push(i.id ));
      self = this;
      const members = this.getTeam.members.filter(function(obj) {
        return self.membersToDelete.indexOf(obj) == -1;
      });
      members.map(i => formData.append("members", i));
      this.$store
        .dispatch("team/updateTeam", { team_id, formData })
        .then(() => {
          this.editTeamMembersDialog = false;
        })
        .catch(err => {
          this.editTeamMembersDialog = true;
        });
    },
    editTeamDialogOpen: function() {
      this.editTeamDialog = true;
      this.selectedFile = null;
      this.teamForm = { ...this.getTeam };
    },
    editTeamDialogSave: function() {
      const team_id = this.$route.params.id;
      const formData = new FormData();
      formData.append("name", this.teamForm.name);
      if (this.selectedFile) {
        formData.append("avatar", this.selectedFile);
      }
      this.$store
        .dispatch("team/updateTeam", { team_id, formData })
        .then(() => {
          this.editTeamDialog = false;
        })
        .catch(err => {
          this.editTeamDialog = true;
        });
    },
    pickFile() {
      this.$refs.changeTeamImage.click();
    },
    onFilePicked(e) {
      const files = e.target.files;
      this.selectedFile = event.target.files[0];
    }
  }
};
</script>

<style scoped>
.team {
  padding-bottom: 100px;
}

.team__preview {
  background-color: #212121;
}

.team__preview-inner {
  padding: 30px 45px;
}

.team__info {
  display: flex;
  /*flex-direction: column;*/
  justify-content: space-between;
  /*min-height: 230px;*/
}

.team__avatar {
  margin-bottom: 15px;
}

.team__about {
}

.team__about-title {
  font-size: 18px;
  margin-bottom: 5px;
}

.team-slider__item:hover {
  box-shadow: 1px 5px 10px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;
}

.team__activities {
  /* display: flex;*/
  flex-direction: column;
  justify-content: space-around;
}

.team__activities-item {
  text-align: center;
  position: relative;
  margin-bottom: 35px;
}

.team__activities-title {
  font-family: "Roboto", sans-serif;
  text-transform: uppercase;
  font-weight: 400;
  margin-bottom: 2px;
}

.team-activity__total {
  display: flex;
  align-items: center;
}

.team__activities-value {
  font-weight: bold;
}

.team__slider-item {
  text-align: center;
}

.team__slider-avartar {
  border: 3px solid;
  padding: 3px;
  background-color: #fff !important;
  display: block;
  box-shadow: 0 1px 5px #fc9667;
  margin-bottom: 5px;
}

.team__slider-name {
}

.edit-dialog {
}

.edit-dialog__inner {
  background-color: #212121;
  min-height: 100vh;
  padding-top: 90px;
}

.edit-dialog__title {
  text-align: center;
  font-size: 24px;
}

.edit-dialog__avatar {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 30px;
  overflow: hidden;
}

.edit-dialog__button {
  width: 100%;
  height: 56px;
}

.edit-dialog__table {
  width: 100%;
  color: #fff;
  text-align: left;
  border-spacing: 0px;
  border-collapse: collapse;
}

.edit-dialog__table-heading {
  border-bottom: 1px solid #fff;
}

.edit-dialog__table-row-checkbox {
  width: 45px;
}

.team-statistics {
}

@media (min-width: 768px) {
  .team-statistics {
    /*padding: 0 10px;*/
  }
}

.team-statistics__table {
  width: 100%;
  /*text-align: left;*/
  border-spacing: 0px;
  border-collapse: collapse;
  font-size: 12px;
  line-height: 1;
}

.team-statistics__table-heading {
  padding: 5px 10px;
  text-align: left;
}

.team-statistics__table-cell {
  padding: 5px 10px;
}

.team-activity__total_zar {
  color: black;
  font-weight: bold;
}
.team-activity__total_nmg {
  color: black;
  font-weight: bold;
}
.team-activity__total_username {
}
.v-btn .v-btn__content {
  justify-content: right;
}
</style>
